module.exports = __webpack_public_path__ + "static/media/clear-wexer.43aaf7a9.svg";